import React from 'react';
import { Table } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { listPaymentLotsAction } from '../../actions/paymentLotsActions';
import es from '../../lang/es';
import PaymentRow from '../Payments/PaymentRow';

const PaymentLot = ({ paymentLot }) => {
    //Dispatch
    const dispatch = useDispatch();
    //Manejo la recarga
    const handleReload = () => {
        //Cargo de nuevo los datos
        dispatch( listPaymentLotsAction() );
    }
    //Render
    return (
        <>
            <Table hover bordered size="sm" className='d-none d-md-table'>
                <thead className="thead-light">
                    <tr>
                        <th>{ es.FIELDS.DATE }</th>
                        <th>{ es.FIELDS.PROCEEDING }</th>
                        <th>{ es.FIELDS.TYPE }</th>
                        <th>{ es.FIELDS.AMOUNT }</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        paymentLot.payments.map( payment => (
                            <PaymentRow
                                key={`payment-row-${payment.id}`}
                                payment={payment}
                                hideState={true}
                                endFunction={handleReload}
                                isMobile={false}
                            />
                        ))
                    }
                </tbody>
                <tfoot className="table-primary">
                    <tr>
                        <td colSpan="3" className="text-right">
                            <h5 className='mb-0'><strong>{ es.FIELDS.TOTAL }</strong></h5>
                        </td>
                        <td className="align-middle text-right">
                            <h5 className='mb-0'><strong>{ es.PAYMENTS.CURRENCY } { paymentLot.total }</strong></h5>
                        </td>
                        <td></td>
                    </tr>
                </tfoot>
            </Table>
            <ul className="list-group list-group-flush d-md-none">
                {
                    paymentLot.payments.map( payment => (
                        <PaymentRow
                            key={`payment-row-${payment.id}`}
                            payment={payment}
                            hideState={true}
                            endFunction={handleReload}
                            isMobile={true}
                        />
                    ))
                }
            </ul>
        </>
    );
};

export default PaymentLot;